/**
 * Slots growing points into fixed-width buckets and sums their y values.
 * @param points - array of growing points {x,y}.
 * @param options - options.
 */
export function xyObjectSlotX(points, options = {}) {
    const { slotWidth = 1 } = options;
    const halfSlot = slotWidth / 2;
    // when we join we will use the center of mass
    const result = [];
    let current = {
        x: Number.NEGATIVE_INFINITY,
        y: 0,
    };
    for (const point of points) {
        const slot = point.x - ((point.x + halfSlot) % slotWidth) + halfSlot;
        if (Math.abs(current.x - slot) > Number.EPSILON) {
            current = {
                x: slot,
                y: 0,
            };
            result.push(current);
        }
        current.y += point.y;
    }
    return result;
}
//# sourceMappingURL=xyObjectSlotX.js.map